import Component from '../../Component';
import { getCookie } from '../../helpers/helpers';

class EPGModel extends Component {
    constructor() {
        super();
        this.state = {
            program_guide: {},
            daily_program: [],
        };

        this.programCheckTimeout = null;

        this.requestLoading = false;
        this.reportLoading = false;
    }

    getTime() {
        $.ajax({
            url: SITE_URL + 'm3/get-time',
            method: 'GET',
            success: response => {
                response = JSON.parse(response);
                let result = {
                    time: response.time,
                }
                this.emit('gotTime', result);
            }
        })
    }
    getProgramGuide(date) {
        if (this.state.program_guide[date]) {
            let response = {}
            response[date] = this.state.program_guide[date]
            this.emit('gotProgramGuide', response);
            return;
        }
        // yyyy-mm-dd
        $.ajax({
            method: "GET",
            url: SITE_URL + 'm3/program-guide?start=' + date,
            success: response => {
                response = JSON.parse(response)
                let program_guide = JSON.parse(JSON.stringify(this.state.program_guide));
                if (response[date]) {
                    program_guide[date] = response[date];
                    this.setState({ program_guide });
                }
                this.emit('gotProgramGuide', response);
            }
        })
    }
}


export default EPGModel;